import React, { useEffect, useRef } from 'react'
import { CurrentTimeIndicator } from '@devexpress/dx-react-scheduler-material-ui'

import Box from '@mui/material/Box'

import colors from '@/assets/scss/_themes-vars.module.scss'

type TimeIndicatorProps = CurrentTimeIndicator.IndicatorProps & {
  /** Center the "now" line on mount. */
  autoScroll?: boolean
}

export function TimeIndicator(props: TimeIndicatorProps) {
  const { top, autoScroll = true } = props
  const indicatorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (autoScroll) indicatorRef.current?.scrollIntoView({ block: 'center' })
  }, [autoScroll])

  return (
    <Box ref={indicatorRef}>
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1,
          left: 0,
          top,
          width: (theme) => theme.spacing(1.5),
          height: (theme) => theme.spacing(1.5),
          borderRadius: '50%',
          transform: 'translate(-50%, -50%)',
          background: colors.red600,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1,
          left: 0,
          top,
          height: '2px',
          borderTop: `2px ${colors.red600} solid`,
          width: '100%',
          transform: 'translate(0, -1px)',
        }}
      />
    </Box>
  )
}

/**
 * For a scheduler embedded in another page (the dashboard card): centering the line
 * would scroll the whole page down to the agenda on load.
 */
export function StaticTimeIndicator(props: CurrentTimeIndicator.IndicatorProps) {
  return <TimeIndicator {...props} autoScroll={false} />
}

export default TimeIndicator